'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chartDateFormat = exports.chartLegendPosition = undefined;

var _isFinite = require('babel-runtime/core-js/number/is-finite');

var _isFinite2 = _interopRequireDefault(_isFinite);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _toArray2 = require('lodash/toArray');

var _toArray3 = _interopRequireDefault(_toArray2);

var _isFunction2 = require('lodash/isFunction');

var _isFunction3 = _interopRequireDefault(_isFunction2);

exports.getDataArray = getDataArray;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var chartLegendPosition = exports.chartLegendPosition = {
  none: 'none',
  top: 'top',
  bottom: 'bottom'
};

var chartDateFormat = exports.chartDateFormat = {
  month: 'dd.MM',
  monthStr: 'dd MMM',
  date: 'dd MMM yyyy',
  shortDate: 'dd.MM.yyyy'
};

function getUniqKeyFor(_ref) {
  var key = _ref.key,
      object = _ref.object;

  var uniqKey = key;
  var i = 1;
  while (object[uniqKey]) {
    uniqKey = key + ' (' + i + ')';
    i += 1;
  }
  return uniqKey;
}

function getDataArray(_ref2) {
  var data = _ref2.data,
      keyName = _ref2.keyName,
      valueName = _ref2.valueName,
      sortBy = _ref2.sortBy;

  var table = data.reduce(function (prev, current) {
    var key = getUniqKeyFor({ key: (0, _isFunction3.default)(keyName) ? keyName(current) : current[keyName], object: prev });
    var value = (0, _isFunction3.default)(valueName) ? valueName(current) : [current[valueName]];
    return (0, _extends4.default)({}, prev, (0, _defineProperty3.default)({}, key, [key].concat((0, _toConsumableArray3.default)(value))));
  }, {});
  var uniqTable = (0, _toArray3.default)(table);

  return !sortBy ? uniqTable : uniqTable.sort(function (first, last) {
    var isValidValues = (0, _isFinite2.default)(first[1]) && (0, _isFinite2.default)(last[1]) || first[1].getTime && last[1].getTime;
    if (isValidValues) {
      return sortBy === 'desc' ? last[1] - first[1] : first[1] - last[1];
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/chart.js
// module id = 261
// module chunks = 1